import thumbImage from "../assets/images/scannerLoading.gif";
const fingerPrintServices = () => {
  // State variables
  let template1 = "";
  let template2 = "";
  let secugenLic = "";
  let quality = 100;
  let imageSrc1 = thumbImage;
  let imageSrc2 = thumbImage;

  // Success callback function for fingerprint capture 1
  const successFunc1 = (result) => {
    if (
      result.ErrorCode === 0 &&
      result != null &&
      result.BMPBase64.length > 0
    ) {
      template1 = result.TemplateBase64;
      imageSrc1 = "data:image/bmp;base64," + result.BMPBase64;
    } else {
      alert(`Fingerprint Capture Error Code: ${result.ErrorCode}.`);
    }
  };

  // Success callback function for fingerprint capture 2
  const successFunc2 = (result) => {
    debugger;
    if (
      result.ErrorCode === 0 &&
      result != null &&
      result.BMPBase64.length > 0
    ) {
      template2 = result.TemplateBase64;
      imageSrc2 = result.BMPBase64;

      console.log("Finger Print Data", template2);
      console.log("Finger Print Image", imageSrc2);
    } else {
      alert(`Fingerprint Capture Error Code: ${result.ErrorCode}.`);
    }
  };

  // Error callback function
  const errorFunc = (status) => {
    debugger;
    alert(`Check if SGIBIOSRV is running; status = ${status}:`);
  };

  // Function to capture fingerprint data
  const callSGIFPGetData = (successCall, failCall) => {
    debugger;
    const uri = "https://localhost:8000/SGIFPCapture";
    const params = `Timeout=10000&Quality=50&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        successCall(data);
      })
      .catch((error) => {
        failCall(error);
      });
  };

  // Function to match fingerprint data
  const matchScore = (succFunction, failFunction) => {
    if (template1 === "" || template2 === "") {
      alert("Please scan two fingers to verify!!");
      return;
    }
    const uri = "https://localhost:8000/SGIMatchScore";
    const params = `template1=${encodeURIComponent(
      template1
    )}&template2=${encodeURIComponent(template2)}&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        succFunction(data);
      })
      .catch((error) => {
        failFunction(error);
      });
  };

  // Modify the matchFingerPrint function to return a Promise
  const matchFingerPrint = (
    template1,
    template2,
    succFunction,
    failFunction
  ) => {
    // Return a new Promise
    return new Promise((resolve, reject) => {
      if (template1 === "" || template2 === "") {
        reject("Please scan two fingers to verify!!");
        return;
      }
      const uri = "https://localhost:8000/SGIMatchScore";
      const params = `template1=${encodeURIComponent(
        template1
      )}&template2=${encodeURIComponent(template2)}&licstr=${encodeURIComponent(
        secugenLic
      )}&templateFormat=ISO`;

      fetch(uri, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Network response was not ok.");
          }
        })
        .then((data) => {
          // Call succFunction with the data
          const result = succFunction(data);
          // Resolve the Promise with the result
          resolve(result);
        })
        .catch((error) => {
          // Call failFunction with the error
          const result = failFunction(error);
          // Reject the Promise with the result
          reject(result);
        });
    });
  };

  // Callback function for successful fingerprint match
  const succMatch = (result) => {
    const idQuality = quality;
    if (result.ErrorCode === 0) {
      if (result.MatchingScore >= idQuality)
        return { matched: true, score: result.MatchingScore };
      else return { matched: false, score: result.MatchingScore };
    } else {
      return {
        error: `Error Scanning Fingerprint ErrorCode = ${result.ErrorCode}`,
      };
    }
  };

  // Callback function for failed fingerprint match
  const failureFunc = (error) => {
    return { error: "On Match Process, failure has been called" };
  };

  // // Callback function for successful fingerprint match
  // const succMatch = (result) => {
  //     const idQuality = quality;
  //     if (result.ErrorCode === 0) {
  //         if (result.MatchingScore >= idQuality)
  //             alert(`MATCHED ! (${result.MatchingScore})`);
  //         else
  //             alert(`NOT MATCHED ! (${result.MatchingScore})`);
  //     } else {
  //         alert(`Error Scanning Fingerprint ErrorCode = ${result.ErrorCode}`);
  //     }
  // };

  // // Callback function for failed fingerprint match
  // const failureFunc = (error) => {
  //     alert("On Match Process, failure has been called");
  // };

  // Return an object containing functions and variables
  return {
    callSGIFPGetData,
    successFunc1,
    successFunc2,
    errorFunc,
    matchScore,
    matchFingerPrint,
    succMatch,
    failureFunc,
  };
};

export default fingerPrintServices;
